import { CircularProgress, Grid, Table } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { useTheme } from '@mui/material/styles'
import { styled } from '@mui/material/styles'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { useNavigate } from 'react-router-dom'

import { useDispatch } from 'react-redux'
import moment from 'moment'
import { TextBold } from '../../../commonComponents/TextStyling'
import { formatNumber, isEmpty } from '../../../utils/AppHelper'
import { currencySymbol } from '../../../utils/AppConstants'
import NoRecordFound from '../../../commonComponents/NoRecordFound'
import serverData from '../../../api/ServerData'
import { logoutUser } from '../../../actions/loginActions'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.opposite,
    fontSize: 16,
    fontWeight: 700
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    fontWeight: 600
  }
}))

export default function Transactions () {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(true)
  const [transactions, setTransactions] = useState([])

  useEffect(function () {
    getTransactions()
  }, [])

  function getTransactions () {
    serverData.getTransactions(
      {},
      result => {
        if (result.status) {
          setTransactions(result.response)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} style={{ display: 'flex' }}>
        <TextBold style={{ fontSize: '24px', marginBottom: 16 }}>
          All transactions
        </TextBold>
      </Grid>

      {loading ? (
        <Grid
          container
          direction={'column'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            width: '100%'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : (
        <EarningsContent data={transactions} />
      )}
    </Grid>
  )
}

function EarningsContent ({ data }) {
  const theme = useTheme()

  return data.length > 0 ? (
    <>
      <TableContainer component={Paper} style={{ borderRadius: '16px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Candidate Name</StyledTableCell>
              <StyledTableCell>Job Title</StyledTableCell>
              <StyledTableCell>Joining Date (Status)</StyledTableCell>
              <StyledTableCell>Left out on</StyledTableCell>
              <StyledTableCell>Payment due on</StyledTableCell>
              <StyledTableCell>Payment amount (Status)</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => (
              <TableRow
                key={row.applicationId}
                sx={{
                  '&:last-child td, &:last-child th': {
                    border: 0
                  }
                }}
              >
                <StyledTableCell>
                  {row.candidateFirstName} {row.candidateLastName}
                </StyledTableCell>
                <StyledTableCell>{row.jobTitle}</StyledTableCell>
                <StyledTableCell>
                  {moment(row.joiningDate).format('MM/DD/YYYY')}{' '}
                  {isEmpty(row.isJoined)
                    ? ''
                    : row.isJoined
                    ? '(Joined)'
                    : '(Not joined)'}
                </StyledTableCell>
                <StyledTableCell>
                  {row.leftOutDate
                    ? moment(row.leftOutDate).format('MM/DD/YYYY')
                    : 'NA'}
                </StyledTableCell>
                <StyledTableCell>
                  {moment(row.guaranteePeriodEndDate).format('MM/DD/YYYY')}
                </StyledTableCell>

                <StyledTableCell
                  style={{
                    color: row.employerPaymentDone
                      ? theme.palette.text.success
                      : theme.palette.text.error
                  }}
                >
                  {currencySymbol} {formatNumber(row.commissionFromEmployer)} (
                  {row.employerPaymentDone ? 'PAID' : 'UNPAID'})
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  ) : (
    <NoRecordFound />
  )
}
